import { useTranslation } from "react-i18next";
import {
    BOOLEAN_FIELD_TYPE,
    TEXT_FIELD_TYPE,
    AUTOCOMPLETE_FIELD_TYPE
} from "../../helpers/constants";
import { convertFlatListFromBackendToTranslatedOptionObject } from "../../helpers/methods";
import { useChannelsFilteringData } from "../../services/channelsService";
import { ChannelPassportButton } from "../../components/buttons/ChannelPassportButton";

export const CHANNELS_TABLE_NAME = "channels_table";

export const useChannelsTableFieldsConfig = () => {
    const { t } = useTranslation();

    const boolToString = (value) => (value ? t("true") : t("false"));

    const { data: filteringData } = useChannelsFilteringData()

    return [
        {
            name: "channel_name",
            getValueCallback: (rowData) => rowData.channel_name,
            label: t("channels.channel_name"),
            filterType: TEXT_FIELD_TYPE,
            sortable: true
        },
        {
            name: "channel_higher_name",
            getValueCallback: (rowData) => rowData.channel_higher_name,
            label: t("channels.channel_higher_name"),
            filterType: AUTOCOMPLETE_FIELD_TYPE,
            fieldConfig: {
                options: filteringData?.channel_higher_name,
                isObjectOption: false
            },
            
        },
        {
            name: "channel_type",
            getValueCallback: (rowData) => rowData.channel_type ? t(`channels.types.${rowData.channel_type}`) : "",
            label: t("channels.channel_type"),
            filterType: AUTOCOMPLETE_FIELD_TYPE,
            fieldConfig: {
                options: convertFlatListFromBackendToTranslatedOptionObject(
                    filteringData?.channel_type,
                    "id",
                    "name",
                    "channels.types",
                ),
                isObjectOption: true,
                disableClearable: true
            },
        },
        {
            name: "channel_person",
            getValueCallback: (rowData) => rowData.channel_person,
            label: t("channels.channel_person"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "channel_phone",
            getValueCallback: (rowData) => rowData.channel_phone,
            label: t("channels.channel_phone"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "channel_mail",
            getValueCallback: (rowData) => rowData.channel_mail,
            label: t("channels.channel_mail"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "channel_legal",
            getValueCallback: (rowData) => rowData.channel_legal ? t(`channels.legals.${rowData.channel_legal}`) : "",
            filterType: AUTOCOMPLETE_FIELD_TYPE,
            fieldConfig: {
                options: convertFlatListFromBackendToTranslatedOptionObject(
                    filteringData?.channel_legal,
                    "id",
                    "name",
                    "channels.legals",
                ),
                isObjectOption: true,
                disableClearable: true
            },
            label: t("channels.channel_legal"),
        },
        {
            name: "channel_nip",
            getValueCallback: (rowData) => rowData.channel_nip,
            label: t("channels.channel_nip"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "channel_regon",
            getValueCallback: (rowData) => rowData.channel_regon,
            label: t("channels.channel_regon"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "channel_note",
            getValueCallback: (rowData) => rowData.channel_note,
            label: t("channels.channel_note"),
            filterType: TEXT_FIELD_TYPE,
        },
        {
            name: "active",
            getValueCallback: (rowData) => boolToString(rowData.active),
            label: t("channels.active"),
            filterType: BOOLEAN_FIELD_TYPE,
        },
        {
            name: "",
            getValueCallback: (rowData) => <ChannelPassportButton channelId={rowData.id}/>,
            label: "",
            filterType: null,
            excludedFromExport: true
        },

    ];
};
